export default "__VITE_ASSET__BLvwSMHC__"